import React from 'react';
import './Processes.css';

import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';
import Icon from '../../../components/Icon/Icon';
import DocumentLinks from '../../../components/DocumentLinks/DocumentLinks';

const processes = ( props ) => (
	<section id="Processes" className="bg-color-1 hasCurve">
		<h2>Processes <span>&</span> Standards</h2>
		<Icon icon="about.caveman" title="A caveman in a prehistoric environment" />
		<div className="processes-info">
			<p>
				At IDSI, we aren't a bunch of Neanderthals. We're evolved. And with that evolution, we have some company-wide processes and standards like setting up folder structures. Who doesn't love a great folder structure? These standards keep us consistent and efficient and ensure our work is the best that it can be. Please learn these processes and standards so you too can be consistent and efficient!
			</p>
			<DocumentLinks docs={ props.docs } />
		</div>
		<CurvedBottom />
	</section>
);

export default processes;



// WEBPACK FOOTER //
// ./src/pages/About/Processes/Processes.js